/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddCategory = () => {
    const [formData, setFormData] = useState({
        name: '',
        is_active: true
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name) {
            toast.error("Category Name is required!");
            return;
        }

        setLoading(true);

        try {
            await postRequest('download-categories', formData);
            toast.success('Category added successfully!');
            navigate('/downloads/categories');
        } catch (error) {
            console.error('Failed to add category:', error);
            toast.error(error?.message || 'Error occurred while creating category.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4 d-flex justify-content-between align-items-center'>
                <h4 className='text-white font-weight-bold'>Add Download Category</h4>
                <button className="btn btn-light font-weight-bold" onClick={() => navigate('/downloads/categories')}>Back to List</button>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Category Name *</label>
                        <input 
                            type='text' 
                            name='name' 
                            className='form-control' 
                            value={formData.name} 
                            onChange={handleChange} 
                            placeholder='e.g., Newsletter'
                            required 
                        />
                    </div>
                    <div className='col-md-6 form-group d-flex align-items-center mt-4'>
                        <div className="custom-control custom-switch">
                            <input 
                                type="checkbox" 
                                className="custom-control-input" 
                                id="statusSwitch" 
                                name="is_active"
                                checked={formData.is_active}
                                onChange={handleChange}
                            />
                            <label className="custom-control-label font-weight-bold" htmlFor="statusSwitch">
                                Active Status
                            </label>
                        </div>
                    </div>
                </div>
                
                <div className="mt-4">
                    <button type='submit' className='btn btn-primary px-4 py-2 font-weight-bold' disabled={loading}>
                        {loading ? 'Adding...' : 'Add Category'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddCategory;
